export class LeadsTranslationConfig {
    public leadMetrics: any;
    public leadLabels: any;
    public leadReportTitles: any;
    public leadChartDimensions: any;
}
